import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../me'
import type { Feature } from '../feature'

/**
 * Put variable definitions for scenario and session when app selection is
 * changed
 */
export const putVariableDefinitionsForSelectedApp = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.app.asObservable.pipe(
      rxjs.filter(TypeChecker.isNotNullish.raw),
      rxjs.mergeMap(app => {
        const actions = []
        if (app.scenarioVariables?.length > 0) {
          // if there are scenario variables for selected app, populate
          // variable definitions for that scenario
          actions.push(
            feature.actions.putDefinitions
              .from('putScenarioVariableDefinitionsForSelectedApp (effect)')
              .create({
                holder: { scenario: { appId: app.id } },
                variables: app.scenarioVariables,
              }),
          )
        }
        if (app.sessionVariables?.length > 0) {
          // if there are session variables for selected app, populate
          // variable definitions for that session
          actions.push(
            feature.actions.putDefinitions
              .from('putSessionVariableDefinitionsForSelectedApp (effect)')
              .create({
                holder: { session: { appId: app.id } },
                variables: app.sessionVariables,
              }),
          )
        }
        return rxjs.from(actions)
      }),
    ),
)
